const ROUTE_FEATURES = [
  ['/administracion/empresa', 'GERENCIAL.EMPRESA_FISCAL'],
  ['/administracion/afip-e-impuestos', 'GERENCIAL.EMPRESA_FISCAL'],
  ['/administracion/redespachos', 'GERENCIAL.EMPRESA_FISCAL'],
  ['/cargas/guias', 'CARGAS.GUIAS'], ['/cargas/fojas', 'CARGAS.FOJAS'],
  ['/repartos', 'CARGAS.REPARTOS'], ['/retiros', 'CARGAS.RETIROS'],
  ['/clientes', 'ADMINISTRACION.CLIENTES'], ['/proveedores', 'ADMINISTRACION.PROVEEDORES'],
  ['/choferes', 'ADMINISTRACION.CHOFERES'], ['/flota', 'ADMINISTRACION.FLOTA'],
  ['/tarifas', 'ADMINISTRACION.TARIFAS'], ['/tesoreria/cobranzas', 'TESORERIA.COBRANZAS'],
  ['/facturacion', 'FACTURACION.COMPROBANTES'], ['/reportes', 'GERENCIAL.REPORTES'],
  ['/seguridad', 'SEGURIDAD'], ['/rrhh', 'RRHH'], ['/stock', 'STOCK'],
  ['/mantenimiento-flota', 'MANTENIMIENTO_FLOTA'], ['/agencias', 'AGENCIAS'],
  ['/informes', 'INFORMES'], ['/ctasctes', 'CTAS_CTES'], ['/cargas', 'CARGAS'],
];
export function getFeatureCodeForPath(path) { const value=String(path||'').toLowerCase(); return ROUTE_FEATURES.find(([prefix])=>value===prefix||value.startsWith(`${prefix}/`))?.[1]||null; }

const MODULE_FEATURE_CODES = {
  'administración': 'ADMINISTRACION',
  cargas: 'CARGAS',
  facturación: 'FACTURACION',
  gerencial: 'GERENCIAL',
  tesorería: 'TESORERIA',
  seguridad: 'SEGURIDAD',
  rrhh: 'RRHH',
  stock: 'STOCK',
  almacenaje: 'STOCK',
  'mantenimiento de flota': 'MANTENIMIENTO_FLOTA',
  agencias: 'AGENCIAS',
  informes: 'INFORMES',
  'ctas ctes': 'CTAS_CTES',
};

export function getModuleFeatureCode(moduleName) {
  return MODULE_FEATURE_CODES[normalizeFeatureKey(moduleName)] || null;
}

// Only these product capability namespaces are supplied by the platform feature
// catalog. Legacy routes and Jet menu codes are not tenant feature flags.
const PLATFORM_FEATURE_CODE = /^(cargas|administracion|tesoreria|facturacion|gerencial|seguridad|rrhh|stock|mantenimiento_flota|agencias|informes|ctas_ctes)(?:\.|$)/;

function normalizeFeatureKey(value) {
  return String(value || '').trim().toLowerCase();
}

function collectFeatureKeys(source, bucket) {
  if (!source) return;

  if (Array.isArray(source)) {
    source.forEach((item) => {
      if (typeof item === 'string') {
        const key = normalizeFeatureKey(item);
        if (key) bucket.add(key);
        return;
      }

      if (!item || typeof item !== 'object') return;
      if (item.enabled === false || item.active === false) return;
      const rawKey = item.code || item.key || item.feature || item.path || item.id;
      const key = normalizeFeatureKey(rawKey);
      if (key) bucket.add(key);
    });
    return;
  }

  if (typeof source === 'object') {
    Object.entries(source).forEach(([key, value]) => {
      if (value === true || value === 1 || value === '1' || value === 'true') {
        const normalized = normalizeFeatureKey(key);
        if (normalized) bucket.add(normalized);
      }
    });
  }
}

export function getTenantFeatureSet(tenant) {
  const featureSet = new Set();
  const candidates = [
    tenant?.features,
    tenant?.enabledFeatures,
    tenant?.featureFlags,
    tenant?.menuFeatures,
    tenant?.enabledMenuOptions,
    tenant?.config?.features,
    tenant?.config?.menuFeatures,
    tenant?.config?.enabledFeatures,
  ];

  candidates.forEach((candidate) => collectFeatureKeys(candidate, featureSet));
  return featureSet.size ? featureSet : null;
}

export function getEntryFeatureKeys(entry) {
  const keys = [];
  const explicitKeys = Array.isArray(entry?.featureCode)
    ? entry.featureCode
    : entry?.featureCode
      ? [entry.featureCode]
      : [];

  explicitKeys.forEach((item) => {
    const key = normalizeFeatureKey(item);
    if (PLATFORM_FEATURE_CODE.test(key)) keys.push(key);
  });

  const mappedFeature = getFeatureCodeForPath(entry?.to);
  if (mappedFeature) keys.push(normalizeFeatureKey(mappedFeature));

  return Array.from(new Set(keys));
}

export function isTenantFeatureEnabled(tenant, entry) {
  const tenantFeatures = getTenantFeatureSet(tenant);
  if (!tenantFeatures) return true;

  const featureKeys = getEntryFeatureKeys(entry);
  if (!featureKeys.length) return true;

  return featureKeys.some((key) => tenantFeatures.has(key));
}

export default {
  getEntryFeatureKeys,
  getModuleFeatureCode,
  getTenantFeatureSet,
  isTenantFeatureEnabled,
};
